export const AUTOMAP_ACCURACY = {
    LOW: 0.30,
    MEDIUM: 0.43,
    HIGH: 0.60,
};

export type AdfDataMapperEntityType = 'source' | 'sink';
export const adfDataMapperComponent = 'ADFDataMapperComponent';
export const adfDataMapperCreateEvent = 'ADFDataMapper create event';
export const adfDataMapperSelectionDone = 'ADFDataMapper selection completed';
export const editADFDataMapperSelection = 'Edit ADFDataMapper selection';
export const adfDataMapperTableCanvasOpened = 'ADFDataMapper table mapping canvas opened';
export const vnetBasedConnection = 'ADFDataMapper connectors referring VNet based LS';
export const columnMappingViewOpened = 'ADFDataMapper column mapping canvas opened';
export const adfDataMapperPolicySelected = 'ADFDataMapper Policy detail selected';
export const startStopClicked = 'ADFDataMapper start/stop clicked';
export const adfDataMapperJsonSettings = 'AdfDataMapperJsonSettings';
